<template>
    <v-progress-circular :size="70" :width="7" color="primary" indeterminate />
</template>

<script>
export default {
    name: "Spinner",
};
</script>
